import {appSessionStorage} from '../checkout/services';

enum priceView {
    incl_tax = 'incl_tax',
    excl_tax = 'excl_tax',
}

import Vue from 'vue';

const initialState = () => {
    return {
      priceView: appSessionStorage.getItem('price-visibility', priceView.incl_tax),
      priceTriggered: appSessionStorage.getItem('price-triggered', false),
    }
};

const state = initialState();

const mutations = {
    SET_PRICE_VIEW(state: object, payload: object): void {
        Vue.set(state, 'priceView', payload);
        appSessionStorage.setItem('price-visibility', payload);
    },
    SET_PRICE_TRIGGERED(state: object, payload: object): void {
      Vue.set(state, 'priceTriggered', payload);
      appSessionStorage.setItem('price-triggered', payload);
    }
};

const actions = {
    setPriceView({commit}, payload: string): void {
        commit('SET_PRICE_VIEW', payload);
    },
    setPriceTriggered({commit}, payload: string): void {
      commit('SET_PRICE_TRIGGERED', payload);
    }
};

const getters = {
    getPriceView: (state: object) => state['priceView'],
    getPriceTriggered: (state: object) => state['priceTriggered'],
};

const GlobalSettings = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default GlobalSettings;
